/* tinybind https://github.com/blikblum/tinybind */
// Fix overwrite default prefix in bind
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.tinybind=e()}(this,function(){"use strict";var s=["prefix","templateDelimiters","rootInterface","preloadData","handler"],a=["binders","formatters","adapters"],n=/^'.*'$|^".*"$/;function e(t){var e=0,i=t;return n.test(t)?i=t.slice(1,-1):"true"===t?i=!0:"false"===t?i=!1:"null"===t?i=null:"undefined"===t?i=void 0:isNaN(t)?e=1:i=Number(t),{type:e,value:i}}function c(t,e){for(var i,n=t.length,r=0,s=0,a=e[0],o=e[1];s<n;){if((r=t.indexOf(a,s))<0){i&&i.push({type:0,value:t.slice(s)});break}if(i||(i=[]),0<r&&s<r&&i.push({type:0,value:t.slice(s,r)}),s=r+a.length,(r=t.indexOf(o,s))<0){var h=t.slice(s-o.length),c=i[i.length-1];c&&0===c.type?c.value+=h:i.push({type:0,value:h});break}var u=t.slice(s,r).trim();i.push({type:1,value:u}),s=r+o.length}return i}var o,h,i,b={binders:{},formatters:{},adapters:{},_prefix:"rv",_fullPrefix:"rv-",get prefix(){return this._prefix},set prefix(t){this._prefix=t,this._fullPrefix=t+"-"},parseTemplate:c,parseType:e,templateDelimiters:["{","}"],rootInterface:".",preloadData:!0,handler:function(t,e,i){this.call(t,e,i.view.models)},fallbackBinder:function(t,e){null!=e?t.setAttribute(this.type,e):t.removeAttribute(this.type)},configure:function(t){var n=this;t&&Object.keys(t).forEach(function(e){var i=t[e];-1<a.indexOf(e)?Object.keys(i).forEach(function(t){n[e][t]=i[t]}):n[e]=i})}};function u(t){return"object"==typeof t&&null!==t}function l(t,e,i){this.keypath=e,this.callback=i,this.objectPath=[],this.parse(),this.obj=this.getRootObject(t),u(this.target=this.realize())&&this.set(!0,this.key,this.target,this.callback)}l.updateOptions=function(t){o=t.adapters,h=Object.keys(o),i=t.rootInterface},l.tokenize=function(t,e){var i,n,r=[],s={i:e,path:""};for(i=0;i<t.length;i++)n=t.charAt(i),~h.indexOf(n)?(r.push(s),s={i:n,path:""}):s.path+=n;return r.push(s),r},l.prototype.parse=function(){var t,e;h.length||function(t){throw new Error("[Observer] "+t)}("Must define at least one adapter interface."),~h.indexOf(this.keypath[0])?(e=this.keypath[0],t=this.keypath.substr(1)):(e=i,t=this.keypath),this.tokens=l.tokenize(t,e),this.key=this.tokens.pop()},l.prototype.realize=function(){for(var t,e,i=this.obj,n=-1,r=0;r<this.tokens.length;r++)e=this.tokens[r],u(i)?(void 0!==this.objectPath[r]?i!==(t=this.objectPath[r])&&(this.set(!1,e,t,this),this.set(!0,e,i,this),this.objectPath[r]=i):(this.set(!0,e,i,this),this.objectPath[r]=i),i=this.get(e,i)):(-1===n&&(n=r),(t=this.objectPath[r])&&this.set(!1,e,t,this));return-1!==n&&this.objectPath.splice(n),i},l.prototype.sync=function(){var t,e,i;(t=this.realize())!==this.target?(u(this.target)&&this.set(!1,this.key,this.target,this.callback),u(t)&&this.set(!0,this.key,t,this.callback),e=this.value(),this.target=t,((i=this.value())!==e||i instanceof Function)&&this.callback.sync()):t instanceof Array&&this.callback.sync()},l.prototype.value=function(){if(u(this.target))return this.get(this.key,this.target)},l.prototype.setValue=function(t){u(this.target)&&o[this.key.i].set(this.target,this.key.path,t)},l.prototype.get=function(t,e){return o[t.i].get(e,t.path)},l.prototype.set=function(t,e,i,n){var r=t?"observe":"unobserve";o[e.i][r](i,e.path,n)},l.prototype.unobserve=function(){for(var t,e,i=0;i<this.tokens.length;i++)e=this.tokens[i],(t=this.objectPath[i])&&this.set(!1,e,t,this);u(this.target)&&this.set(!1,this.key,this.target,this.callback)},l.prototype.getRootObject=function(t){var e,i;if(!t.$parent)return t;for(e=this.tokens.length?this.tokens[0].path:this.key.path,i=t;i.$parent&&void 0===i[e];)i=i.$parent;return i};var f=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")};var d=/[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g,p=/\s+/,v=function(){function o(t,e,i,n,r,s,a){f(this,o),this.view=t,this.el=e,this.type=i,this.keypath=n,this.binder=r,this.arg=s,this.formatters=a,this.formatterObservers={},this.model=void 0}return o.prototype.observe=function(t,e){return new l(t,e,this)},o.prototype.parseTarget=function(){if(this.keypath){var t=e(this.keypath);0===t.type?this.value=t.value:(this.observer=this.observe(this.view.models,this.keypath),this.model=this.observer.target)}else this.value=void 0},o.prototype.parseFormatterArguments=function(t,s){var a=this;return t.map(e).map(function(t,e){var i=t.type,n=t.value;if(0===i)return n;a.formatterObservers[s]||(a.formatterObservers[s]={});var r=a.formatterObservers[s][e];return r||(r=a.observe(a.view.models,n),a.formatterObservers[s][e]=r),r.value()})},o.prototype.formattedValue=function(t){var o=this;return this.formatters.reduce(function(t,e,i){var n=e.match(d),r=n.shift(),s=o.view.options.formatters[r],a=o.parseFormatterArguments(n,i);return s&&s.read instanceof Function?t=s.read.apply(s,[t].concat(a)):s instanceof Function&&(t=s.apply(void 0,[t].concat(a))),t},t)},o.prototype.eventHandler=function(e){var i=this,n=i.view.options.handler;return function(t){n.call(e,this,t,i)}},o.prototype.set=function(t){t=t instanceof Function&&!this.binder.function?this.formattedValue(t.call(this.model)):this.formattedValue(t);var e=this.binder.routine||this.binder;e instanceof Function&&e.call(this,this.el,t)},o.prototype.sync=function(){this.observer?(this.model=this.observer.target,this.set(this.observer.value())):this.set(this.value)},o.prototype.publish=function(){var o=this;if(this.observer){var t=this.formatters.reduceRight(function(t,e,i){var n=e.split(p),r=n.shift(),s=o.view.options.formatters[r],a=o.parseFormatterArguments(n,i);return s&&s.publish&&(t=s.publish.apply(s,[t].concat(a))),t},this.getValue(this.el));this.observer.setValue(t)}},o.prototype.bind=function(){this.parseTarget(),this.binder.hasOwnProperty("bind")&&this.binder.bind.call(this,this.el),this.view.options.preloadData&&this.sync()},o.prototype.unbind=function(){var i=this;this.binder.unbind&&this.binder.unbind.call(this,this.el),this.observer&&this.observer.unobserve(),Object.keys(this.formatterObservers).forEach(function(t){var e=i.formatterObservers[t];Object.keys(e).forEach(function(t){e[t].unobserve()})}),this.formatterObservers={}},o.prototype.update=function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};this.observer&&(this.model=this.observer.target),this.binder.update&&this.binder.update.call(this,t)},o.prototype.getValue=function(t){return this.binder&&this.binder.getValue?this.binder.getValue.call(this,t):(i=[],"checkbox"===(e=t).type?e.checked:"select-multiple"===e.type?(e.options.forEach(function(t){t.selected&&i.push(t.value)}),i):e.value);var e,i},o}(),y={routine:function(t,e){t.data=null!=e?e:""}},m=/((?:'[^']*')*(?:(?:[^\|']*(?:'[^']*')+[^\|']*)+|[^\|]+))|^$/g,r=function t(e,i){var n=!1;if(3===i.nodeType){var r=c(i.data,b.templateDelimiters);if(r){for(var s=0;s<r.length;s++){var a=r[s],o=document.createTextNode(a.value);i.parentNode.insertBefore(o,i),1===a.type&&e.buildBinding(o,null,a.value,y,null)}i.parentNode.removeChild(i)}n=!0}else 1===i.nodeType&&(n=e.traverse(i));if(!n)for(var h=0;h<i.childNodes.length;h++)t(e,i.childNodes[h])},g=function(t,e){var i=t.binder&&t.binder.priority||0;return(e.binder&&e.binder.priority||0)-i},k=function(t){return t.trim()},O=function(){function n(t,e,i){f(this,n),t.jquery||t instanceof Array?this.els=t:this.els=[t],this.models=e,this.options=i,this.build()}return n.prototype.buildBinding=function(t,e,i,n,r){var s=i.match(m).map(k),a=s.shift();this.bindings.push(new v(this,t,e,a,n,r,s))},n.prototype.build=function(){this.bindings=[];var t,e=this.els,i=void 0;for(i=0,t=e.length;i<t;i++)r(this,e[i]);this.bindings.sort(g)},n.prototype.traverse=function(t){for(var e,i,n,r,s=this.options.prefix?this.options.prefix+'-':b._fullPrefix,a="SCRIPT"===t.nodeName||"STYLE"===t.nodeName,o=t.attributes,h=[],c=this.options.starBinders,u=0,l=o.length;u<l;u++){var f=o[u];if(0===f.name.indexOf(s)){if(e=f.name.slice(s.length),r=void 0,!(i=this.options.binders[e]))for(var d=0;d<c.length;d++)if(n=c[d],e.slice(0,n.length-1)===n.slice(0,-1)){i=this.options.binders[n],r=e.slice(n.length-1);break}if(i||(i=b.fallbackBinder),i.block)return this.buildBinding(t,e,f.value,i,r),t.removeAttribute(f.name),!0;h.push({attr:f,binder:i,type:e,arg:r})}}for(var p=0;p<h.length;p++){var v=h[p];this.buildBinding(t,v.type,v.attr.value,v.binder,v.arg),t.removeAttribute(v.attr.name)}return a},n.prototype.bind=function(){this.bindings.forEach(function(t){t.bind()})},n.prototype.unbind=function(){this.bindings.forEach(function(t){t.unbind()})},n.prototype.sync=function(){this.bindings.forEach(function(t){t.sync()})},n.prototype.publish=function(){this.bindings.forEach(function(t){t.binder&&t.binder.publishes&&t.publish()})},n.prototype.update=function(){var e=this,i=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};Object.keys(i).forEach(function(t){e.models[t]=i[t]}),this.bindings.forEach(function(t){t.update&&t.update(i)})},n}(),w=["push","pop","shift","unshift","sort","reverse","splice"],t={counter:0,weakmap:{},weakReference:function(t){if(!t.hasOwnProperty("__rv")){var e=this.counter++;Object.defineProperty(t,"__rv",{value:e})}return this.weakmap[t.__rv]||(this.weakmap[t.__rv]={callbacks:{}}),this.weakmap[t.__rv]},cleanupWeakReference:function(t,e){Object.keys(t.callbacks).length||t.pointers&&Object.keys(t.pointers).length||delete this.weakmap[e]},stubFunction:function(r,t){var s=r[t],a=this.weakReference(r),o=this.weakmap;r[t]=function(){for(var t=arguments.length,e=Array(t),i=0;i<t;i++)e[i]=arguments[i];var n=s.apply(r,e);return Object.keys(a.pointers).forEach(function(t){var e=a.pointers[t];o[t]&&o[t].callbacks[e]instanceof Array&&o[t].callbacks[e].forEach(function(t){t.sync()})}),n}},observeMutations:function(e,t,i){var n=this;if(e instanceof Array){var r=this.weakReference(e);r.pointers||(r.pointers={},w.forEach(function(t){n.stubFunction(e,t)})),r.pointers[t]||(r.pointers[t]=[]),-1===r.pointers[t].indexOf(i)&&r.pointers[t].push(i)}},unobserveMutations:function(t,e,i){if(t instanceof Array&&null!=t.__rv){var n=this.weakmap[t.__rv];if(n){var r=n.pointers[e];if(r){var s=r.indexOf(i);-1<s&&r.splice(s,1),r.length||delete n.pointers[e],this.cleanupWeakReference(n,t.__rv)}}}},observe:function(n,r,t){var s,a=this,e=this.weakReference(n).callbacks;if(!e[r]){e[r]=[];var i=Object.getOwnPropertyDescriptor(n,r);i&&(i.get||i.set||!i.configurable)||(s=n[r],Object.defineProperty(n,r,{enumerable:!0,get:function(){return s},set:function(t){if(t!==s){a.unobserveMutations(s,n.__rv,r),s=t;var e=a.weakmap[n.__rv];if(e){var i=e.callbacks[r];i&&i.forEach(function(t){t.sync()}),a.observeMutations(t,n.__rv,r)}}}}))}-1===e[r].indexOf(t)&&e[r].push(t),this.observeMutations(n[r],n.__rv,r)},unobserve:function(t,e,i){var n=this.weakmap[t.__rv];if(n){var r=n.callbacks[e];if(r){var s=r.indexOf(i);-1<s&&(r.splice(s,1),r.length||(delete n.callbacks[e],this.unobserveMutations(t[e],t.__rv,e))),this.cleanupWeakReference(n,t.__rv)}}},get:function(t,e){return t[e]},set:function(t,e,i){t[e]=i}},E=function(t){return null!=t?t.toString():void 0};function _(t,e,i){var n=t.el.cloneNode(!0),r=new O(n,e,t.view.options);return r.bind(),t.marker.parentNode.insertBefore(n,i),r}var j={"on-*":{function:!0,priority:1e3,unbind:function(t){this.handler&&t.removeEventListener(this.arg,this.handler)},routine:function(t,e){this.handler&&t.removeEventListener(this.arg,this.handler),this.handler=this.eventHandler(e),t.addEventListener(this.arg,this.handler)}},"each-*":{block:!0,priority:4e3,bind:function(t){this.marker?this.iterated.forEach(function(t){t.bind()}):(this.marker=document.createComment(" tinybind: "+this.type+" "),this.iterated=[],t.parentNode.insertBefore(this.marker,t),t.parentNode.removeChild(t))},unbind:function(t){this.iterated&&this.iterated.forEach(function(t){t.unbind()})},routine:function(t,e){var h=this,c=this.arg;e=e||[];var u=t.getAttribute("index-property")||"$index";e.forEach(function(t,e){var i={$parent:h.view.models};i[u]=e,i[c]=t;var n=h.iterated[e];if(n)if(n.models[c]!==t){for(var r=void 0,s=void 0,a=e+1;a<h.iterated.length;a++)if((s=h.iterated[a]).models[c]===t){r=a;break}void 0!==r?(h.iterated.splice(r,1),h.marker.parentNode.insertBefore(s.els[0],n.els[0]),s.models[u]=e):s=_(h,i,n.els[0]),h.iterated.splice(e,0,s)}else n.models[u]=e;else{var o=h.marker;h.iterated.length&&(o=h.iterated[h.iterated.length-1].els[0]),n=_(h,i,o.nextSibling),h.iterated.push(n)}}),this.iterated.length>e.length&&function(t,e){for(var i=0;i<t;i++)e()}(this.iterated.length-e.length,function(){var t=h.iterated.pop();t.unbind(),h.marker.parentNode.removeChild(t.els[0])}),"OPTION"===t.nodeName&&this.view.bindings.forEach(function(t){t.el===h.marker.parentNode&&"value"===t.type&&t.sync()})},update:function(e){var i=this,n={};Object.keys(e).forEach(function(t){t!==i.arg&&(n[t]=e[t])}),this.iterated.forEach(function(t){t.update(n)})}},"class-*":function(t,e){var i=" "+t.className+" ";!e==-1<i.indexOf(" "+this.arg+" ")&&(t.className=e?t.className+" "+this.arg:i.replace(" "+this.arg+" "," ").trim())},text:function(t,e){t.textContent=null!=e?e:""},html:function(t,e){t.innerHTML=null!=e?e:""},show:function(t,e){t.style.display=e?"":"none"},hide:function(t,e){t.style.display=e?"none":""},enabled:function(t,e){t.disabled=!e},disabled:function(t,e){t.disabled=!!e},checked:{publishes:!0,priority:2e3,bind:function(t){var e=this;this.callback||(this.callback=function(){e.publish()}),t.addEventListener("change",this.callback)},unbind:function(t){t.removeEventListener("change",this.callback)},routine:function(t,e){"radio"===t.type?t.checked=E(t.value)===E(e):t.checked=!!e}},value:{publishes:!0,priority:3e3,bind:function(t){if(this.isRadio="INPUT"===t.tagName&&"radio"===t.type,!this.isRadio){this.event=t.getAttribute("event-name")||("SELECT"===t.tagName?"change":"input");var e=this;this.callback||(this.callback=function(){e.publish()}),t.addEventListener(this.event,this.callback)}},unbind:function(t){this.isRadio||t.removeEventListener(this.event,this.callback)},routine:function(t,e){if(this.isRadio)t.setAttribute("value",e);else if("select-multiple"===t.type){if(e instanceof Array)for(var i=0;i<t.length;i++){var n=t[i];n.selected=-1<e.indexOf(n.value)}}else E(e)!==E(t.value)&&(t.value=null!=e?e:"")}},if:{block:!0,priority:4e3,bind:function(t){this.marker?!1===this.bound&&this.nested&&this.nested.bind():(this.marker=document.createComment(" tinybind: "+this.type+" "+this.keypath+" "),this.attached=!1,t.parentNode.insertBefore(this.marker,t),t.parentNode.removeChild(t)),this.bound=!0},unbind:function(){this.nested&&(this.nested.unbind(),this.bound=!1)},routine:function(t,e){!!e!==this.attached&&(e?(this.nested||(this.nested=new O(t,this.view.models,this.view.options),this.nested.bind()),this.marker.parentNode.insertBefore(t,this.marker.nextSibling),this.attached=!0):(t.parentNode.removeChild(t),this.attached=!1))},update:function(t){this.nested&&this.nested.update(t)}}};return b.binders=j,b.adapters["."]=t,b.bind=function(t,e,i){var n={};e=e||{},i=i||{},a.forEach(function(e){n[e]=Object.create(null),i[e]&&Object.keys(i[e]).forEach(function(t){n[e][t]=i[e][t]}),Object.keys(b[e]).forEach(function(t){n[e][t]||(n[e][t]=b[e][t])})}),s.forEach(function(t){var e=i[t];n[t]=null!=e?e:b[t]}),n.starBinders=Object.keys(n.binders).filter(function(t){return 0<t.indexOf("*")}),l.updateOptions(n);var r=new O(t,e,n);return r.bind(),r},b.formatters.negate=b.formatters.not=function(t){return!t},b});

window.theme = window.theme || {};
var $ = jQuery.noConflict();

theme.utils = {

  each: function(collection, iterator) {
      if (Array.isArray(collection)) {
          for (var i = 0; i < collection.length; i++)
              iterator(collection[i], i, collection);
      } else if (collection instanceof Object) {
          for (var key in collection)
              iterator(collection[key], key, collection);
      } else if (collection === null) {
          return collection;
      }
  },

  map: function(collection, iterator) {
    var arr = [];
    theme.utils.each(collection, function(el, index) {
        arr.push(iterator(el, index));
    });
    return arr;
  },

  extend: function(obj) {
      theme.utils.each(arguments, function(extendObj) {
          for (var key in extendObj)
              obj[key] = extendObj[key];
      });
      return obj;
  },

  handleize: function(str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  },

  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  getSizedImageUrl: function(src, size) {
    var _ref, _ref1;
    if (((_ref = window.Shopify) != null ? (_ref1 = _ref.Image) != null ? _ref1.getSizedImageUrl : void 0 : void 0) != null) {
      if (src) {
        return theme.Image.getSizedImageUrl(src, size);
      } else {
        return theme.Image.getSizedImageUrl('https://cdn.shopify.com/s/images/admin/no-image-.gif', size).replace('-_', '-');
      }
    } else {
      if (src) {
        return src;
      } else {
        return 'https://cdn.shopify.com/s/images/admin/no-image-large.gif';
      }
    }
  },

  getQueryParams: function(qs) {
    qs = qs || document.location.search;

    if (!qs) { 
      return;
    }

    qs = qs.split('+').join(' ');

    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
  },

  // getSizedImageUrl: function(src, size) {
  //   if (size === null) {
  //     return src;
  //   }

  //   if (size === 'master') {
  //     return this.removeProtocol(src);
  //   }

  //   var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  //   if (match) {
  //     var prefix = src.split(match[0]);
  //     var suffix = match[0];

  //     return removeProtocol(prefix[0] + '_' + size + suffix);
  //   } else {
  //     return null;
  //   }

  //   function removeProtocol(path) {
  //     return path.replace(/http(s)?:/, '');
  //   }
  // }

}

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();


/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = theme.utils.defaultTo(precision, 2);
      thousands = theme.utils.defaultTo(thousands, ',');
      decimal = theme.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();



// Cart.js
// version: 0.4.1
// author: Gavin Ballard
// license: MIT
// Updated with:
// - Error handling from https://github.com/discolabs/cartjs/issues/68#issuecomment-261418409
// - Properties regex pattern modified to support spaces
// - Removed rivets, replaced with tinybind
// - Added NProgress loading bar increment on queue step
// - Prevents AJAX forms when active file inputs exist in form
// - Improved Tinybind array element formatter logic
// - Tinybind money formatter removes trailing '.00' in result
// - Returns updated items in requestComplete event
// - Returns request errors in requestComplete event

(function() {
  var $document, Cart, CartJS, Item, processing, queue, updatedLineItems, requestErrors,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  Cart = (function() {
    function Cart() {
      this.update = __bind(this.update, this);
    }

    Cart.prototype.update = function(cart) {
      var item, key, value;
      for (key in cart) {
        value = cart[key];
        if (key !== 'items') {
          this[key] = value;
        }
      }
      return this.items = (function() {
        var _i, _len, _ref, _results;
        _ref = cart.items;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          item = _ref[_i];
          _results.push(new Item(item));
        }
        return _results;
      })();
    };

    return Cart;

  })();

  Item = (function() {
    function Item(item) {
      this.propertyArray = __bind(this.propertyArray, this);
      this.update = __bind(this.update, this);
      this.update(item);
    }

    Item.prototype.update = function(item) {
      var key, value;
      for (key in item) {
        value = item[key];
        if (key !== 'properties') {
          this[key] = value;
        }
      }
      return this.properties = CartJS.Utils.extend({}, item.properties);
    };

    Item.prototype.propertyArray = function() {
      var name, value, _ref, _results;
      _ref = this.properties;
      _results = [];
      for (name in _ref) {
        value = _ref[name];
        _results.push({
          name: name,
          value: value
        });
      }
      return _results;
    };

    return Item;

  })();

  CartJS = {
    settings: {
      debug: false,
      dataAPI: true,
      requestBodyClass: null,
      tinybindModels: {},
      currency: null,
      moneyFormat: null,
      moneyWithCurrencyFormat: null,
      weightUnit: 'g',
      weightPrecision: 0,
      errorHandling: {
        cartError: function(error) {
          if (this.description) {
            console.log("There was an error adding an item to the cart:", this.description);
          } else {
            console.log("There was an error adding an item to the cart:", this);
          }
        }
      },
    },
    cart: new Cart()
  };

  CartJS.init = function(cart, settings) {
    if (settings == null) {
      settings = {};
    }
    CartJS.configure(settings);
    CartJS.Utils.log('Initialising CartJS.');
    CartJS.cart.update(cart);
    if (CartJS.settings.dataAPI) {
      CartJS.Utils.log('"dataAPI" setting is true, initialising Data API.');
      CartJS.Data.init();
    }
    if (CartJS.settings.requestBodyClass) {
      CartJS.Utils.log('"requestBodyClass" set, adding event listeners.');
      jQuery(document).on('cart.requestStarted', function() {
        return jQuery('body').addClass(CartJS.settings.requestBodyClass);
      });
      jQuery(document).on('cart.requestComplete', function() {
        return jQuery('body').removeClass(CartJS.settings.requestBodyClass);
      });
    }
    CartJS.tinybind.init();
    return jQuery(document).trigger('cart.ready', [CartJS.cart]);
  };

  CartJS.configure = function(settings) {
    if (settings == null) {
      settings = {};
    }
    return CartJS.Utils.extend(CartJS.settings, settings);
  };

  if (window.console == null) {
    window.console = {};
    window.console.log = function() {};
  }

  CartJS.Utils = {
    log: function() {
      return CartJS.Utils.console(console.log, arguments);
    },
    error: function() {
      return CartJS.Utils.console(console.error, arguments);
    },
    console: function(method, args) {
      if (CartJS.settings.debug && (typeof console !== "undefined" && console !== null)) {
        args = Array.prototype.slice.call(args);
        args.unshift('[CartJS]:');
        return method.apply(console, args);
      }
    },
    wrapKeys: function(obj, type, override) {
      var key, value, wrapped;
      if (type == null) {
        type = 'properties';
      }
      wrapped = {};
      for (key in obj) {
        value = obj[key];
        wrapped["" + type + "[" + key + "]"] = override != null ? override : value;
      }
      return wrapped;
    },
    unwrapKeys: function(obj, type, override) {
      var key, unwrapped, unwrappedKey, value;
      if (type == null) {
        type = 'properties';
      }
      unwrapped = {};
      for (key in obj) {
        value = obj[key];
        unwrappedKey = key.replace("" + type + "[", "").replace("]", "");
        unwrapped[unwrappedKey] = override != null ? override : value;
      }
      return unwrapped;
    },
    extend: function(object, properties) {
      var key, val;
      for (key in properties) {
        val = properties[key];
        object[key] = val;
      }
      return object;
    },
    clone: function(object) {
      var key, newInstance;
      if ((object == null) || typeof object !== 'object') {
        return object;
      }
      newInstance = new object.constructor();
      for (key in object) {
        newInstance[key] = clone(object[key]);
      }
      return newInstance;
    },
    isArray: Array.isArray || function(value) {
      return {}.toString.call(value) === '[object Array]';
    },
    ensureArray: function(value) {
      if (CartJS.Utils.isArray(value)) {
        return value;
      }
      if (value != null) {
        return [value];
      } else {
        return [];
      }
    },
    formatMoney: function(value, format, formatName, currency) {
      var _ref, _ref1;
      if (currency == null) {
        currency = '';
      }
      if (!currency) {
        currency = CartJS.settings.currency;
      }
      if ((window.Currency != null) && currency !== CartJS.settings.currency) {
        value = Currency.convert(value, CartJS.settings.currency, currency);
        if ((((_ref = window.Currency) != null ? _ref.moneyFormats : void 0) != null) && (currency in window.Currency.moneyFormats)) {
          format = window.Currency.moneyFormats[currency][formatName];
        }
      }
      if (((_ref1 = window.Shopify) != null ? _ref1.formatMoney : void 0) != null) {
        return theme.Currency.formatMoney(value, format);
      } else {
        return value;
      }
    },
    getSizedImageUrl: function(src, size) {
      var _ref, _ref1;
      if (((_ref = window.Shopify) != null ? (_ref1 = _ref.Image) != null ? _ref1.getSizedImageUrl : void 0 : void 0) != null) {
        if (src) {
          return theme.Image.getSizedImageUrl(src, size);
        } else {
          return theme.Image.getSizedImageUrl('https://cdn.shopify.com/s/images/admin/no-image-.gif', size).replace('-_', '-');
        }
      } else {
        if (src) {
          return src;
        } else {
          return 'https://cdn.shopify.com/s/images/admin/no-image-large.gif';
        }
      }
    }
  };

  queue = [];

  updatedLineItems = [];

  requestErrors = [];

  processing = false;

  CartJS.Queue = {
    add: function(url, data, options) {
      var request;
      if (options == null) {
        options = {};
      }
      request = {
        url: url,
        data: data,
        type: options.type || 'POST',
        dataType: options.dataType || 'json',
        statusCode: {
          422: function(a) {
            if (typeof CartJS.settings.errorHandling.cartError === 'function') {
              requestErrors.push(a.responseJSON);
              CartJS.settings.errorHandling.cartError.call(a.responseJSON);
            }
          }
        },
        success: CartJS.Utils.ensureArray(options.success),
        error: CartJS.Utils.ensureArray(options.error),
        complete: CartJS.Utils.ensureArray(options.complete)
      };
      if (options.updateCart) {
        request.success.push(CartJS.cart.update);
      }
      queue.push(request);
      if (processing) {
        return;
      }
      jQuery(document).trigger('cart.requestStarted', [CartJS.cart]);
      return CartJS.Queue.process();
    },
    process: function(data) {
      var params;

      if (data && data.responseJSON.id) {
        updatedLineItems.push(data.responseJSON);
      }

      if (!queue.length) {
        processing = false;

        var updatedCart = CartJS.cart;
        updatedCart.updatedLineItems = updatedLineItems;
        updatedCart.errors = requestErrors;

        jQuery(document).trigger('cart.requestComplete', [updatedCart]);
        updatedLineItems = [];
        requestErrors = [];
        return;
      }

      if ('NProgress' in window && $('#nprogress').length) {
        NProgress.inc();
      }
      
      processing = true;
      params = queue.shift();
      
      params.complete = CartJS.Queue.process;
      return jQuery.ajax(params);
    }
  };

  CartJS.Core = {
    getCart: function(options) {
      if (options == null) {
        options = {};
      }
      options.type = 'GET';
      options.updateCart = true;
      return CartJS.Queue.add('/cart.js', {}, options);
    },
    addItem: function(id, quantity, properties, options) {
      var data;
      if (quantity == null) {
        quantity = 1;
      }
      if (properties == null) {
        properties = {};
      }
      if (options == null) {
        options = {};
      }
      data = CartJS.Utils.wrapKeys(properties);
      data.id = id;
      data.quantity = quantity;
      CartJS.Queue.add('/cart/add.js', data, options);
      return CartJS.Core.getCart();
    },
    updateItem: function(line, quantity, properties, options) {
      var data;
      if (properties == null) {
        properties = {};
      }
      if (options == null) {
        options = {};
      }
      data = CartJS.Utils.wrapKeys(properties);
      data.line = line;
      if (quantity != null) {
        data.quantity = quantity;
      }
      options.updateCart = true;
      return CartJS.Queue.add('/cart/change.js', data, options);
    },
    removeItem: function(line, options) {
      if (options == null) {
        options = {};
      }
      return CartJS.Core.updateItem(line, 0, {}, options);
    },
    updateItemById: function(id, quantity, properties, options) {
      var data;
      if (properties == null) {
        properties = {};
      }
      if (options == null) {
        options = {};
      }
      data = CartJS.Utils.wrapKeys(properties);
      data.id = id;
      if (quantity != null) {
        data.quantity = quantity;
      }
      options.updateCart = true;
      return CartJS.Queue.add('/cart/change.js', data, options);
    },
    updateItemQuantitiesById: function(updates, options) {
      if (updates == null) {
        updates = {};
      }
      if (options == null) {
        options = {};
      }
      options.updateCart = true;
      return CartJS.Queue.add('/cart/update.js', {
        updates: updates
      }, options);
    },
    removeItemById: function(id, options) {
      var data;
      if (options == null) {
        options = {};
      }
      data = {
        id: id,
        quantity: 0
      };
      options.updateCart = true;
      return CartJS.Queue.add('/cart/change.js', data, options);
    },
    clear: function(options) {
      if (options == null) {
        options = {};
      }
      options.updateCart = true;
      return CartJS.Queue.add('/cart/clear.js', {}, options);
    },
    getAttribute: function(attributeName, defaultValue) {
      if (attributeName in CartJS.cart.attributes) {
        return CartJS.cart.attributes[attributeName];
      } else {
        return defaultValue;
      }
    },
    setAttribute: function(attributeName, value, options) {
      var attributes;
      if (options == null) {
        options = {};
      }
      attributes = {};
      attributes[attributeName] = value;
      return CartJS.Core.setAttributes(attributes, options);
    },
    getAttributes: function() {
      return CartJS.cart.attributes;
    },
    setAttributes: function(attributes, options) {
      if (attributes == null) {
        attributes = {};
      }
      if (options == null) {
        options = {};
      }
      options.updateCart = true;
      return CartJS.Queue.add('/cart/update.js', CartJS.Utils.wrapKeys(attributes, 'attributes'), options);
    },
    clearAttributes: function(options) {
      if (options == null) {
        options = {};
      }
      options.updateCart = true;
      return CartJS.Queue.add('/cart/update.js', CartJS.Utils.wrapKeys(CartJS.Core.getAttributes(), 'attributes', ''), options);
    },
    getNote: function() {
      return CartJS.cart.note;
    },
    setNote: function(note, options) {
      if (options == null) {
        options = {};
      }
      options.updateCart = true;
      return CartJS.Queue.add('/cart/update.js', {
        note: note
      }, options);
    }
  };

  $document = null;

  CartJS.Data = {
    init: function() {
      $document = jQuery(document);
      CartJS.Data.setEventListeners('on');
      return CartJS.Data.render(null, CartJS.cart);
    },
    destroy: function() {
      return CartJS.Data.setEventListeners('off');
    },
    setEventListeners: function(method) {
      $document[method]('click', '[data-cart-add]', CartJS.Data.add);
      $document[method]('click', '[data-cart-remove]', CartJS.Data.remove);
      $document[method]('click', '[data-cart-remove-id]', CartJS.Data.removeById);
      $document[method]('click', '[data-cart-update]', CartJS.Data.update);
      $document[method]('click', '[data-cart-update-id]', CartJS.Data.updateById);
      $document[method]('click', '[data-cart-clear]', CartJS.Data.clear);
      $document[method]('change', '[data-cart-toggle]', CartJS.Data.toggle);
      $document[method]('change', '[data-cart-toggle-attribute]', CartJS.Data.toggleAttribute);
      $document[method]('submit', '[data-cart-submit]', CartJS.Data.submit);
      return $document[method]('cart.requestComplete', CartJS.Data.render);
    },
    add: function(e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      var properties = {};
      if($this.attr('data-cart-property')){
        properties = JSON.parse($this.attr('data-cart-property'));
      }
      return CartJS.Core.addItem($this.attr('data-cart-add'), $this.attr('data-cart-quantity'), properties);
    },
    remove: function(e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      return CartJS.Core.removeItem($this.attr('data-cart-remove'));
    },
    removeById: function(e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      return CartJS.Core.removeItemById($this.attr('data-cart-remove-id'));
    },
    update: function(e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      return CartJS.Core.updateItem($this.attr('data-cart-update'), $this.attr('data-cart-quantity'));
    },
    updateById: function(e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      return CartJS.Core.updateItemById($this.attr('data-cart-update-id'), $this.attr('data-cart-quantity'));
    },
    clear: function(e) {
      e.preventDefault();
      return CartJS.Core.clear();
    },
    toggle: function(e) {
      var $input, id;
      $input = jQuery(this);
      id = $input.attr('data-cart-toggle');
      if ($input.is(':checked')) {
        return CartJS.Core.addItem(id);
      } else {
        return CartJS.Core.removeItemById(id);
      }
    },
    toggleAttribute: function(e) {
      var $input, attribute;
      $input = jQuery(this);
      attribute = $input.attr('data-cart-toggle-attribute');
      return CartJS.Core.setAttribute(attribute, $input.is(':checked') ? 'Yes' : '');
    },
    submit: function(e) {
      var dataArray, id, properties, quantity;
      // Prevent AJAX forms when file inputs exist
      if (jQuery(this).find('input[type="file"]:enabled').length) {
        return;
      }

      e.preventDefault();
      dataArray = jQuery(this).serializeArray();

      id = void 0;
      quantity = void 0;
      properties = {};
      jQuery.each(dataArray, function(i, item) {
        if (item.name === 'id') {
          return id = item.value;
        } else if (item.name === 'quantity') {
          return quantity = item.value;
        } else if (item.name.match(/^properties\[[-\w\s]+\]$/)) {
          return properties[item.name] = item.value;
        }
      });
      return CartJS.Core.addItem(id, quantity, CartJS.Utils.unwrapKeys(properties));
    },
    render: function(e, cart) {
      var context;
      context = {
        'item_count': cart.item_count,
        'total_price': cart.total_price,
        'total_price_money': CartJS.Utils.formatMoney(cart.total_price, CartJS.settings.moneyFormat, 'money_format', (typeof Currency !== "undefined" && Currency !== null ? Currency.currentCurrency : void 0) != null ? Currency.currentCurrency : void 0),
        'total_price_money_with_currency': CartJS.Utils.formatMoney(cart.total_price, CartJS.settings.moneyWithCurrencyFormat, 'money_with_currency_format', (typeof Currency !== "undefined" && Currency !== null ? Currency.currentCurrency : void 0) != null ? Currency.currentCurrency : void 0)
      };
      return jQuery('[data-cart-render]').each(function() {
        var $this;
        $this = jQuery(this);
        return $this.html(context[$this.attr('data-cart-render')]);
      });
    }
  };

  if ('tinybind' in window) {
    CartJS.tinybind = {
      model: null,
      boundViews: [],
      init: function() {
        return CartJS.tinybind.bindViews();
      },
      destroy: function() {
        return CartJS.tinybind.unbindViews();
      },
      bindViews: function() {
        CartJS.Utils.log('tinybind.js is present, binding views.');
        CartJS.tinybind.unbindViews();
        CartJS.tinybind.model = CartJS.Utils.extend({
          cart: CartJS.cart
        }, CartJS.settings.tinybindModels);
        if (window.Currency != null) {
          CartJS.tinybind.model.Currency = window.Currency;
        }
        return jQuery('[data-cart-view]').each(function() {
          var view;
          view = tinybind.bind(jQuery(this), CartJS.tinybind.model);
          return CartJS.tinybind.boundViews.push(view);
        });
      },
      unbindViews: function() {
        var view, _i, _len, _ref;
        _ref = CartJS.tinybind.boundViews;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          view = _ref[_i];
          view.unbind();
        }
        return CartJS.tinybind.boundViews = [];
      }
    };
    tinybind.formatters.eq = function(a, b) {
      return a === b;
    };
    tinybind.formatters.includes = function(a, b) {
      return a.indexOf(b) >= 0;
    };
    tinybind.formatters.match = function(a, regexp, flags) {
      return a.match(new RegExp(regexp, flags));
    };
    tinybind.formatters.lt = function(a, b) {
      return a < b;
    };
    tinybind.formatters.gt = function(a, b) {
      return a > b;
    };
    // tinybind.formatters.not = function(a) {
    //   return !a;
    // };
    tinybind.formatters.empty = function(a) {
      return (a ? !a.length : true);
    };
    tinybind.formatters.plus = function(a, b) {
      return parseInt(a) + parseInt(b);
    };
    tinybind.formatters.minus = function(a, b) {
      return parseInt(a) - parseInt(b);
    };
    tinybind.formatters.times = function(a, b) {
      return a * b;
    };
    tinybind.formatters.divided_by = function(a, b) {
      return a / b;
    };
    tinybind.formatters.round_up = function(a) {
      return Math.ceil(a)
    };
    tinybind.formatters.modulo = function(a, b) {
      return a % b;
    };
    tinybind.formatters.prepend = function(a, b) {
      return b + a;
    };
    tinybind.formatters.append = function(a, b) {
      return a + b;
    };
    tinybind.formatters.slice = function(value, start, end) {
      return value.slice(start, end);
    };
    tinybind.formatters.pluralize = function(input, singular, plural) {
      if (plural == null) {
        plural = singular + 's';
      }
      if (CartJS.Utils.isArray(input)) {
        input = input.length;
      }
      if (input === 1) {
        return singular;
      } else {
        return plural;
      }
    };
    tinybind.formatters.array_element = function(array, index) {
      return (array ? array[index] : null);
    };
    tinybind.formatters.array_first = function(array) {
      return array[0];
    };
    tinybind.formatters.array_last = function(array) {
      return array[array.length - 1];
    };
    tinybind.formatters.money = function(value, currency) {
      return CartJS.Utils.formatMoney(value, CartJS.settings.moneyFormat, 'money_format', currency);
    };
    tinybind.formatters.money_without_trailing_zeros = function(value, currency) {
      return CartJS.Utils.formatMoney(value, CartJS.settings.moneyFormat, 'money_format', currency).replace(/\.00$/, '');
    };
    tinybind.formatters.money_with_currency = function(value, currency) {
      return CartJS.Utils.formatMoney(value, CartJS.settings.moneyWithCurrencyFormat, 'money_with_currency_format', currency).replace('.00', '');
    };
    tinybind.formatters.weight = function(grams) {
      switch (CartJS.settings.weightUnit) {
        case 'kg':
          return (grams / 1000).toFixed(CartJS.settings.weightPrecision);
        case 'oz':
          return (grams * 0.035274).toFixed(CartJS.settings.weightPrecision);
        case 'lb':
          return (grams * 0.00220462).toFixed(CartJS.settings.weightPrecision);
        default:
          return grams.toFixed(CartJS.settings.weightPrecision);
      }
    };
    tinybind.formatters.weight_with_unit = function(grams) {
      return tinybind.formatters.weight(grams) + CartJS.settings.weightUnit;
    };
    tinybind.formatters.product_image_size = function(src, size) {
      return CartJS.Utils.getSizedImageUrl(src, size);
    };
    tinybind.formatters.moneyWithCurrency = tinybind.formatters.money_with_currency;
    tinybind.formatters.weightWithUnit = tinybind.formatters.weight_with_unit;
    tinybind.formatters.productImageSize = tinybind.formatters.product_image_size;
  } else {
    CartJS.tinybind = {
      init: function() {},
      destroy: function() {}
    };
  }

  CartJS.factory = function(exports) {
    exports.init = CartJS.init;
    exports.configure = CartJS.configure;
    exports.cart = CartJS.cart;
    exports.settings = CartJS.settings;
    exports.getCart = CartJS.Core.getCart;
    exports.addItem = CartJS.Core.addItem;
    exports.updateItem = CartJS.Core.updateItem;
    exports.updateItemById = CartJS.Core.updateItemById;
    exports.updateItemQuantitiesById = CartJS.Core.updateItemQuantitiesById;
    exports.removeItem = CartJS.Core.removeItem;
    exports.removeItemById = CartJS.Core.removeItemById;
    exports.clear = CartJS.Core.clear;
    exports.getAttribute = CartJS.Core.getAttribute;
    exports.setAttribute = CartJS.Core.setAttribute;
    exports.getAttributes = CartJS.Core.getAttributes;
    exports.setAttributes = CartJS.Core.setAttributes;
    exports.clearAttributes = CartJS.Core.clearAttributes;
    exports.getNote = CartJS.Core.getNote;
    exports.setNote = CartJS.Core.setNote;
    return exports.render = CartJS.Data.render;
  };

  if (typeof exports === 'object') {
    CartJS.factory(exports);
  } else if (typeof define === 'function' && define.amd) {
    define(['exports'], function(exports) {
      CartJS.factory(this.CartJS = exports);
      return exports;
    });
  } else {
    CartJS.factory(this.CartJS = {});
  }

}).call(this);

/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
!function(n){n.fn.prepareTransition=function(){return this.each(function(){var i=n(this);i.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){i.removeClass("is-transitioning")});var t=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"],o=0;n.each(t,function(n,t){o||(o=parseFloat(i.css(t)))}),0!=o&&(i.addClass("is-transitioning"),i[0].offsetWidth)})}}(jQuery);



/*!
tua-body-scroll-lock
https://github.com/tuateam/tua-body-scroll-lock
*/
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t((e=e||self).bodyScrollLock={})}(this,function(e){"use strict";function t(e,t,o){return t in e?Object.defineProperty(e,t,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[t]=o,e}function o(e){for(var o=1;o<arguments.length;o++){var n=null!=arguments[o]?arguments[o]:{},i=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(i=i.concat(Object.getOwnPropertySymbols(n).filter(function(e){return Object.getOwnPropertyDescriptor(n,e).enumerable}))),i.forEach(function(o){t(e,o,n[o])})}return e}var n,i=0,r=0,l=null,c=!1,s="undefined"==typeof window,u=[],d=!s&&document.querySelector.bind(document);if(!s){var f={get passive(){n={passive:!1}}};window.addEventListener("__TUA_BSL_TEST_PASSIVE__",null,f),window.removeEventListener("__TUA_BSL_TEST_PASSIVE__",null,f)}var a=function(){var e=navigator.userAgent,t=/(iPad).*OS\s([\d_]+)/.test(e),o=!t&&/(iPhone\sOS)\s([\d_]+)/.test(e),n=/(Android);?[\s\/]+([\d.]+)?/.test(e);return{os:n?"android":"ios",ios:o||t,ipad:t,iphone:o,android:n}},h=function(e){e.cancelable&&e.preventDefault()};e.lock=function(e){var t,f,y,p,v;s||(a().ios?(e&&-1===u.indexOf(e)&&(e.ontouchstart=function(e){r=e.targetTouches[0].clientY},e.ontouchmove=function(t){1===t.targetTouches.length&&function(e,t){var o=e.targetTouches[0].clientY-r;if(t){var n=t.scrollTop,i=t.scrollHeight,l=t.clientHeight;if(o>0&&0===n||o<0&&n+l+1>=i)return h(e)}e.stopPropagation()}(t,e)},u.push(e)),c||(document.addEventListener("touchmove",h,n),c=!0)):i<=0&&(l=a().android?(t=d("html"),f=d("body"),y=t.scrollTop||f.scrollTop,p=o({},t.style),v=o({},f.style),t.style.height="100%",t.style.overflow="hidden",f.style.top="-".concat(y,"px"),f.style.width="100%",f.style.height="auto",f.style.position="fixed",f.style.overflow="hidden",function(){t.style.height=p.height||"",t.style.overflow=p.overflow||"",["top","width","height","overflow","position"].forEach(function(e){f.style[e]=v[e]||""}),window.scrollTo(0,y)}):function(){var e=d("body"),t=o({},e.style),n=window.innerWidth-document.body.clientWidth;return e.style.overflow="hidden",e.style.boxSizing="border-box",e.style.paddingRight="".concat(n,"px"),function(){["overflow","boxSizing","paddingRight"].forEach(function(o){e.style[o]=t[o]||""})}}()),i+=1)},e.unlock=function(e){if(!(s||(i-=1)>0))if(a().ios){var t=u.indexOf(e);-1!==t&&(e.ontouchmove=null,e.ontouchstart=null,u.splice(t,1)),c&&(document.removeEventListener("touchmove",h,n),c=!1)}else i<=0&&"function"==typeof l&&l()},Object.defineProperty(e,"__esModule",{value:!0})});



/*============================================================================
  View Bindings
==============================================================================*/
 if ('tinybind' in window) {

  tinybind.formatters.replace = function(value, search, replace) {
    return value.replace(search, replace);
  };

  tinybind.formatters.handle = function(string) {
    return theme.utils.handleize(string);
  };

  tinybind.formatters.startsWith = function(value, prefix) {
    return value.indexOf(prefix) === 0;
  };

  tinybind.formatters.endsWith = function(value, suffix) {
    return value.indexOf(suffix, value.length - suffix.length) !== -1;
  };

  tinybind.formatters.gte = function(a, b) {
    return a >= b;
  };

  tinybind.formatters.or = function(a, b) {
    return a || b;
  };

  tinybind.formatters.and = function(a, b) {
    return a && b;
  };

  tinybind.formatters.size = function(a) {
    return a && a.length;
  };

  tinybind.formatters.minus = function(a,b) {
    return a - b;
  };

  tinybind.formatters.money = function(value) {
    return theme.Currency.formatMoney(value);
  };

  tinybind.formatters.replace = function(a,b,c) {
    return a.replace(b,c);
  };


  tinybind.formatters.length = tinybind.formatters.size;

  tinybind.formatters.stripHtml = function(html) {
    var parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    return parsedHtml.body.textContent || "";
  };

  tinybind.formatters.escape = function(string) {
    return JSON.stringify(string).replace(/(^"|"$)/g, '');
  };

  tinybind.formatters.json = function(a) {
    return JSON.stringify(a);
  };

  tinybind.formatters.log = function(value) {
    console.log(value);
    return value;
  };

  tinybind.formatters.format_tel = function(value) {
    return value ? value.toString().replace(/\ /g, '') : value;
  };

  tinybind.formatters.array_position = function(array, value) {
    return (value >= 0 ? array[value] : array[array.length + value]);
  };

  tinybind.formatters.percentage_of = function(a, b) {
    return b / a * 100;
  };

  tinybind.formatters.contains = function(a, b) {
    return (a.indexOf(b) > -1);
  };

  tinybind.formatters.imageExists = function(a) {
    return (a && a.indexOf('no-image') == -1);
  };

  tinybind.formatters.highlight = function(a, b) {
    if (b && a) {
      return theme.utils.highlightSubString(b, a);
    }
    return;
  };

  tinybind.formatters.passedMinSpendRules = function(a,b) {
    // a is cart.items - so event trigger updates, b is cart to get cart total
    if (a) {
      var failedMinSpendProducts = [];
      for (var i = 0; i < a.length; i++) {
        var item = a[i];
        if(item.properties && item.properties['_min_spend']){
          var minSpendAmount = parseFloat(item.properties._min_spend);

          var totalExcludingMinSpend = b.total_price - (item.discounted_price * item.quantity);
          if(totalExcludingMinSpend < minSpendAmount){
            failedMinSpendProducts.push(item);
          }
        }
      }

      if(failedMinSpendProducts.length > 0){
        return false;
      }
    }
    return true;
  };



  

  tinybind.formatters['price_with_addons'] = function(line_item) {
    var linePrice = line_item.line_price;

    for (var i = 0; i < CartJS.cart.items.length; i++) {
      if (CartJS.cart.items[i].key != line_item.key && CartJS.cart.items[i].properties._optionGroup != undefined && CartJS.cart.items[i].properties._optionGroup == line_item.properties._optionGroup) {
        linePrice += CartJS.cart.items[i].line_price;
      }
    }

    return linePrice;
  };

  tinybind.formatters.img = function(image, alt, maxWidth, maxHeight) {

    if (!image) {
      return;
    }

    var imgTemplateURL,
        imgString,
        imgUrl;

    imgUrl = (typeof image == 'string' ? image : image.src);

    imgTemplateURL = image; //theme.utils.getSizedImageUrl(imgUrl, '{width}x');

    maxWidth = maxWidth ? ((image.width ? image.width + 'px' : false) || (typeof maxWidth == 'string' ? maxWidth : maxWidth + 'px')) : 'none';
    maxHeight = maxHeight ? ((image.height ? image.height + 'px' : false) || (typeof maxHeight == 'string' ? maxHeight : maxHeight + 'px')) : 'none';

    alt = alt || null;

    imgString = '<img src="'+imgTemplateURL+'" class="" style="max-width: ' + maxWidth + '; max-height: ' + maxHeight + ';" data-sizes="auto" data-src="' + imgTemplateURL + '" alt="' + alt + ' "/>'

    return imgString;
  };

  tinybind.formatters.map = function(a, b) {
    
    function map(collection, iterator) {
      var arr = [];
      theme.utils.each(collection, function(el, index) {
          arr.push(iterator(el, index));
      });
      return arr;
    }
    return map(a, b);
  };

  tinybind.binders.selected = function(el, value) {
    if (value) {
      el.selected = 'selected';
    }
  };

  tinybind.binders['slideshow'] = {

    bind: function(el) {
      this.el;
      this.displayCount;
      this.track;
      this.slides;
      this.buttons;
      this.isInit = false;
      this.currentSlideIndex = 0;
      this.slidesToShow = 1;

      var NAMESPACE = 'slideshow';
      var SLIDSHOW_ELEMENT_CLASS_NAME = 'slideshow-view';
      var SLIDSHOW_BUTTONS_CLASS_NAME = 'slideshow-button';
      var NEXT_DIRECTION_NAME = 'next';
      var PREV_DIRECTION_NAME = 'previous';

      var self = this;

      var enableOrDisableButton = function(button) {
        var direction = button.name;
        if (direction == NEXT_DIRECTION_NAME && self.currentSlideIndex == self.slides - 1) {
          button.disabled = true;
        } else if (direction == PREV_DIRECTION_NAME && self.currentSlideIndex == 0) {
          button.disabled = true;
        } else {
          button.disabled = false;
        }
      };

      var goToNextSlide = function() {
        if (self.currentSlideIndex < self.slides - 1) {
          goToSlide(self.currentSlideIndex + 1);
        }
      };

      var goToPrevSlide = function() {
        if (self.currentSlideIndex > 0) {
          goToSlide(self.currentSlideIndex - 1);
        }
      };

      var goToSlide = function(slideIndex) {
        var currentSlide = self.slides[self.currentSlideIndex];
        var targetSlide = self.slides[slideIndex];

        self.track.style.transform = 'translateX(' + slideIndex / self.slidesToShow * -100 + '%)';

        if (currentSlide) {
          currentSlide.setAttribute('aria-hidden', true);
        }
        if (targetSlide) {
          targetSlide.setAttribute('aria-hidden', false);
        }
        

        self.currentSlideIndex = slideIndex;

        Array.prototype.forEach.call(self.buttons, function(button) {
          enableOrDisableButton(button);
        });
      };

      var getButtonsTemplate = function(direction) {
        var templateNamePrefix = 'slider-button-';
        return $('[data-template-for="' + templateNamePrefix + direction + '"]').html();
      };

      this._createSlideshow = function(el, options) {

        self.displayMobile = parseInt(self.el.dataset.slidesToShowMobile);
        self.displayDesktop = parseInt(self.el.dataset.slidesToShowDesktop);
        self.displayCount = parseInt(self.el.dataset.slidesToShow);

        var width = window.innerWidth;
        if (width > 1024) {
          self.displayCount = self.displayDesktop;
        }
        else {
          self.displayCount = self.displayMobile;
        }

        
        self.track = self.el.firstElementChild;
        self.slides = self.displayCount;

        self.el.classList.add(SLIDSHOW_ELEMENT_CLASS_NAME);

        Array.prototype.forEach.call(self.slides, function(slide, index) {
          slide.setAttribute('aria-hidden', index != self.currentSlideIndex);
        });

        self.el.addEventListener(NEXT_DIRECTION_NAME + '.' + NAMESPACE, goToNextSlide);
        self.el.addEventListener(PREV_DIRECTION_NAME + '.' + NAMESPACE, goToPrevSlide);

        self.buttons = [NEXT_DIRECTION_NAME, PREV_DIRECTION_NAME].map(function(direction) {
          var button = document.createElement('button');

          button.setAttribute('name', direction);

          button.classList.add(SLIDSHOW_BUTTONS_CLASS_NAME);
          button.classList.add(SLIDSHOW_BUTTONS_CLASS_NAME + '--' + direction);

          button.innerHTML = getButtonsTemplate(direction);

          button.addEventListener('click', function() {
            self.el.dispatchEvent(new Event(direction + '.' + NAMESPACE));
          });

          self.el.parentNode.appendChild(button);

          enableOrDisableButton(button);

          return button;
        });

        self.isInit = true;

      };

      this._destroySlideshow = function(el) {

        if (!self.isInit) {
          return;
        }

        self.el.classList.remove(SLIDSHOW_ELEMENT_CLASS_NAME);

        self.el.removeEventListener(NEXT_DIRECTION_NAME + '.' + NAMESPACE, self.nextSlide);
        self.el.removeEventListener(PREV_DIRECTION_NAME + '.' + NAMESPACE, self.prevSlide);

        Array.prototype.forEach.call(self.buttons, function(button) {
          button.remove();
        });

        self.isInit = false;

      };

    },

    unbind: function(el) {
      this._destroySlideshow(el);
    },

    routine: function(el, value) {
      value == true ? this._createSlideshow(el) : this._destroySlideshow(el);
    }

  };

  tinybind.binders['cart-add'] = {
    bind: function(el) {

      var self = this;

      this.callback = function(variantId) {
        var variantId = self.variantId || el.dataset.variantId;
        var quantity = el.dataset.quantity || 1;
        var productProperties = [];
        var propertyInputs = document.querySelector('.cart-drawer-gift-inner[data-item="'+variantId+'"]').getElementsByTagName('input');
        var properties = Array.prototype.map.call(propertyInputs, function(propertyInput) {
          if (propertyInput.name.indexOf('properties') == -1) {
            return false;
          }
          var properyName = propertyInput.name.replace('properties[', '').replace(']', '');
          productProperties[properyName] = propertyInput.value;
        })
   
        el.classList.add('loading');
        CartJS.addItem(variantId, quantity, productProperties, {
          "success": function(data, textStatus, jqXHR) {
               el.classList.remove('loading');
          },
          "error": function(jqXHR, textStatus, errorThrown) {
              alert('Error: ' + errorThrown + '!');
          }
        });
      }

      el.addEventListener('click', this.callback);
    },

    unbind: function(el) {
      el.removeEventListener('click', this.callback);
    },

    routine: function(el, value) {
      this.variantId = value;
    }
  };

  tinybind.binders['cart-remove'] = {
    bind: function(el) {

      var self = this;

      this.callback = function(variantId) {
        var variantId = self.variantId || el.dataset.variantId;

        var lineItemInCart = document.querySelector('#cart-drawer-item-'+variantId +' .cart-item-remove');
        var lineItemIndex = lineItemInCart.dataset.cartRemove;

        el.classList.add('loading');
        CartJS.removeItem(lineItemIndex);
      }

      el.addEventListener('click', this.callback);
    },

    unbind: function(el) {
      el.removeEventListener('click', this.callback);
    },

    routine: function(el, value) {
      this.variantId = value;
    }
  };

  tinybind.binders['product-grid-item'] = function(el, product) {
    var gridIndex = el.dataset.index;
    var animateIn = typeof el.dataset.animateIn != 'undefined' ? el.dataset.animateIn : true;
    var options = {
      animateIn: animateIn == 'true' ? true : false
    };
    new theme.ProductGridItem(el, product, gridIndex, options);
  };

  tinybind.binders.transformx = function(el, value) {
    el.style[theme.utils.getCSSProperty('transform')] = 'translateX(' + value + ')';
  };

  tinybind.binders['scroll-to'] = function(el, value) {
    var parent;

    if (value) {
      parent = el.parentElement;
      $(parent).scrollTo(el, {
          duration: 500,
          interrupt: !isMobile.apple.device,
          offset: -20
      });
    }
  };

}

window.theme.drawers = window.theme.drawers || {};
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {

  if ('Hammer' in window && isMobile.any) {
    theme.pageSwipeObject = new Hammer.Manager(document.getElementById('PageContainer'), {
      touchAction: 'auto',
      inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchMouseInput,
      recognizers: [
        [Hammer.Swipe, {
          direction: Hammer.DIRECTION_HORIZONTAL
        }]
      ]
    });

    theme.pageSwipeObject.on('swiperight', function(evt) {
      if ($('body').hasClass('js-drawer-open-right')) {
        var $drawer = $('.drawer.drawer--right');
        theme[$drawer.attr('id')].close();
        return;
      }

      var $drawer = $('.drawer.drawer--left');
      if (!$drawer.length) {
        return;
      }
      var delta_x = evt.deltaX;
      var final_x = evt.srcEvent.pageX || evt.srcEvent.screenX || 0;
      var startPosition = final_x - delta_x;
      if (startPosition >= 0 && startPosition <= 25) {
        theme[$drawer.attr('id')].open();
      }
      return false;
    });

    theme.pageSwipeObject.on('swipeleft', function(evt) {
      if ($('body').hasClass('js-drawer-open-left')) {
        var $drawer = $('.drawer.drawer--left');
        theme[$drawer.attr('id')].close();
        return;
      }

      var $drawer = $('.drawer.drawer--right');
      if (!$drawer.length) {
        return;
      }

      return;  // Do not open ajax cart with swipe right

      var delta_x = evt.deltaX;
      var final_x = evt.center.x || 0;
      var startPosition = final_x + -delta_x;
      var windowWidthOffset = $(window).width() - 25;
      if (startPosition >= windowWidthOffset) {
        theme[$drawer.attr('id')].open();
      }
      return false;
    });
  }
  
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position,
      pageContentSelector: '#site-main',
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $(this.config.pageContentSelector)
    };

    this.$drawer = $('#' + id);

    this.$drawer.addClass('drawer--' + position);

    if (!this.$drawer.length) {
      return false;
    }

    theme.drawers[id] = this;

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
    $('.PageOverlay').on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.closeAllDrawers = function(evt) {
    // Close all drawers
    for (var i = 0; i < theme.drawers.length; i++) {
    	var drawer = theme.drawers[i];
    	if (drawer.drawerIsOpen) {
    	  drawer.close();
    	}
    }
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    jQuery('.PageOverlay').addClass('is-visible');


    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    this.closeAllDrawers();

    // Run function when draw opens if set
    if (this.config.beforeDrawerOpen && typeof this.config.beforeDrawerOpen === 'function') {
      // if (!externalCall) {
        this.config.beforeDrawerOpen(this);
      // }
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();
    this.$drawer.addClass('is-open');

    this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    //lock page scroll
    // var scrollEl = this.$drawer.find('.enable-scroll-xs');
    // document.documentElement.classList.add('scroll-locked');
    // if ('bodyScrollLock' in window) {
    //   bodyScrollLock.lock(scrollEl);
    // }

    // Set focus on drawer
    trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    function trapFocus(options){
    	var eventName = options.namespace
	      ? 'focusin.' + options.namespace
	      : 'focusin';

	    if (!options.$elementToFocus) {
	      options.$elementToFocus = options.$container;
	    }

	    options.$container.attr('tabindex', '-1');
	    options.$elementToFocus.focus();

	    jQuery(document).on(eventName, function(evt) {
	      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
	        options.$container.focus();
	      }
	    });
    }

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen(this);
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    jQuery(document.activeElement).trigger('blur');

    jQuery('.PageOverlay').removeClass('is-visible');
    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();
    this.$drawer.removeClass('is-open');

    this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    //unlockpagescroll
    // document.documentElement.classList.remove('scroll-locked');
    // if ('bodyScrollLock' in window) {
    //   bodyScrollLock.unlock();
    // }

    // Remove focus on drawer
    removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });
    function removeTrapFocus(options) {
	    var eventName = options.namespace
	      ? 'focusin.' + options.namespace
	      : 'focusin';

	    if (options.$container && options.$container.length) {
	      options.$container.removeAttr('tabindex');
	    }

	    jQuery(document).off(eventName);
	  }

    // Run function when draw opens if set
    if (this.config.onDrawerClose && typeof this.config.onDrawerClose === 'function') {
      this.config.onDrawerClose();
    }

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    //this.nodes.$parent.on('keyup.drawer', $.proxy(function(evt) {
      //// close on 'esc' keypress
      //if (evt.keyCode === 27) {
        //this.close();
        //return false;
      //} else {
        //return true;
      //}
    //}, this));

    // Lock scrolling on mobile
    // this.nodes.$page.on('touchmove.drawer', function() {
    //   return false;
    // });

    //this.nodes.$page.on('click.drawer', $.proxy(function() {
//
      //if (!this.$drawer[0].contains(event.target)) {
        //this.close();
      //}
//
    //}, this));
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  Drawer.prototype.getProperties = function() {
    var header, headerLowerHeight, offsetTop;

    if (document.body.classList.contains('show-product-sticky')) {
      var productSticky = document.querySelector('.product-sticky');
      offsetTop = theme.utils.getBottomOffsetFromViewportTop(productSticky);
    } else if (document.body.classList.contains('show-header-lower')) {
      var headerLower = document.querySelector('.site-header-lower');
      offsetTop = theme.utils.getBottomOffsetFromViewportTop(headerLower);
    } else {
      // Calc height of visible header elements
      header = document.querySelector('.header');
      offsetTop = theme.utils.getBottomOffsetFromViewportTop(header);
    }

    return {
      top: Math.floor(offsetTop) + 'px',
      height: 'calc(100% - ' + Math.floor(offsetTop) + 'px)',
    };
  };

  return Drawer;
})();


/*============================================================================
  AJAX Cart 
==============================================================================*/
window.theme = window.theme || {};

theme.AjaxCart = (function() {
  var selectors = {
    addToCartBtn: '[type="submit"]',
    addToCartForm: 'form[action="/cart/add"]',
    cartCount: '[data-header-cart-count]',
    cartToggle: '.site-header-cart-button',
    cartDrawer: '.cart-drawer',
    cartDrawerOpen: '.site-header-cart-button',
    cartDrawerTabs: '.cart-drawer__tabs',
  };

  var settings = {
    // 'aboveForm' for top of add to cart form, 
    // 'belowForm' for below the add to cart form, 
    // 'nextButton' for next to add to cart button and
    // 'afterBody' for after the main body content (used for fixed notifications).
    feedbackPosition: 'afterBody'
  };

  var options = {
    requestBodyClass: 'cart-loading',
    moneyFormat: window.shop.moneyFormat,
    moneyWithCurrencyFormat: window.shop.moneyWithCurrencyFormat,
    weightUnit: 'kg', // g, kg, oz, lb
    weightPrecision: 0,
    tinybindModels: {
      'customer': window.shop.customer,
      'cartGifts': window.shop.cartGifts,
      'cartUpsell': window.shop.cartUpsell,
      'methods': {
        updateQuantityFromSelect: function() {
          var quantity = this.options[this.selectedIndex].value;
          var line_number = this.dataset.lineIndex;
          CartJS.updateItem(line_number, quantity);
        },
        removePromotionItem: function() {
          console.log('remove item:', this);
          // var quantity = 0;
          // var line_number = this.dataset.lineIndex;
          // CartJS.updateItem(line_number, quantity);
        },
        toggleSelectGift: function(event, binding){
          var variantId = binding.option.product.variants[0].id;

          if (binding.option.selected) {
            var variantId = binding.option.product.variants[0].id;
            binding.option.selected = false;
            for (var i = 0; i < window.shop.cartGifts.selected.length; i++) {
              if(window.shop.cartGifts.selected[i] == variantId){
                window.shop.cartGifts.selected.splice(i, 1);
              }
            }

          }
          else {
            binding.option.selected = true;
            if (!window.shop.cartGifts.selected.indexOf(variantId) > -1) {
              window.shop.cartGifts.selected.push(variantId); 
            }
          }
          window.shop.cartGifts.selectedCount = window.shop.cartGifts.selected.length;

          
        },


      }
    },
    errorHandling: {
      cartError: function() {
        $('.cart-loader.loading').removeClass('loading');
        if (this.description) {
          showFeedback('error', this.description);
        }
      }
    }
  };

  var cache = {
    previousCartItems: [],
    updatedItems: []
  };

  function init() {
    if (!$(selectors.cartDrawer).length) {
      return;
    }

    var $tabsGroup = $(selectors.cartDrawerTabs);
    $.each($tabsGroup, function(index, tabsGroup) {
      window.theme.tabsGroups[tabsGroup] = new theme.TabsGroup(tabsGroup, {
        breakpoint: 0
      });
    });

    $(document).on('click', '[data-add-to-cart], [data-cart-add], [data-cart-update], [data-cart-update-id], [data-cart-remove]', function(evt){
      var $this = jQuery(this);
      var progressElementSelector = $this.data('progress-element');
      var $progressElement = progressElementSelector ? jQuery(progressElementSelector) : $this;
      
      if (!$this.is('.disabled')) {
        if ($progressElement.length) {
          $progressElement.addClass('cart-loader loading');
        }

        if ($this.is('[data-opens-cart-drawer]')) {
          $('body').addClass('cart-loading--opens-drawer');
        }

        if ($this.is('[data-opens-cart-drawer]')) {
          $('body').addClass('cart-loading--opens-drawer');
        }

        if ($this.is('[data-displays-success]')) {
          $('body').addClass('cart-loading--trigger-displays-success');
          $(document).on('addToCartSuccess', function(event, cart) {
            $(document).off('addToCartSuccess');

            $this.height($this.height());

            var text = $this.data('success-text');
            text = text.replace('%icon.checkmark%', window.icons.checkmark)

            $this.attr('data-text', $this.html());
            $this.html(text);
            $this.addClass('Button--success')

            setTimeout(function() {
              $this.text($this.data('text'));
              $this.removeClass('Button--success');
              $this.height($this.height(''));
            }, 3000)

          })
        }

      } else {
        evt.preventDefault();
        evt.stopPropagation();

        $progressElement.addClass('error');
        window.setTimeout(function(){
          $progressElement.removeClass('error');
        }, 1500);

        var highlightElements = $this.data('enable-requirements');
        if (highlightElements) {
          theme.utils.flash(highlightElements);
        }
      }
    });
    
    initDrawer();

    $(selectors.cartDrawerOpen).on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openCartDrawer();
    });

    // tippy('.cart-drawer', { 
    //   target: '.cart-drawer-item__remove, .cart-drawer__close',
    //   theme: 'light',
    //   placement: 'left',
    //   animation: 'shift-away',
    //   arrow: true,
    //   offset: 0,
    //   distance: 5,
    // });

    CartJS.init(window.shop.cart, options);

    $('#cart-drawer-note, #cart-note').on('blur', function() {
      var note = $(this).val();
      if (note) {
        CartJS.setNote(note);
      } else {
        CartJS.setNote('');
      }
    });

    $('.cart-drawer__submit').click(function(){
      $(document.body).addClass('checkout-activated');
    });

    $(document).on('cart.requestStarted', function(event, cart) {
      // cache.previousCartItems = _.values(_.omit(cart.items, _.functions(cart.items)));
      
      if ('NProgress' in window) {
        NProgress.start();
      }
    });

    $(document).on('cart.requestComplete', function(event, cart) {
      if ('NProgress' in window) {
        NProgress.done();
      }

      jQuery(selectors.cartCount).text(cart.item_count);
      
      jQuery('.cart-loader.loading').removeClass('loading');

      // cache.updatedItems = theme.utils.difference(_.values(_.omit(cart.items, _.functions(cart.items))), cache.previousCartItems);
      // _.remove(cache.updatedItems, _.isEmpty);

      cache.updatedItems = cart.updatedLineItems;
      
      if (!cache.updatedItems.length && cart.items.length > 0) {
        // showFeedback('error', theme.strings.quantityUnavailable);
      }
      
      shop.cart = cart;

      if (theme.Favicon !== undefined) {
        if (cart.item_count > 0) {
          theme.Favicon.set(cart.item_count);
        } else {
          theme.Favicon.reset();
        }
      }

      var $body = jQuery('body');

      var opensDrawer = $body.is('.cart-loading--opens-drawer');

      if ($body.is('.cart-loading--trigger-displays-success') && cache.updatedItems && cache.updatedItems.length) {
        $body.removeClass('cart-loading--trigger-displays-success');
        $(document).trigger('addToCartSuccess');
      }
      
      if (opensDrawer !== undefined && opensDrawer) {
        if ((theme.cartQueue === undefined || theme.cartQueue.length == 0) && theme.cartQueueProcessing == false) {
          if (!theme.CartDrawer.drawerIsOpen) {
            $body.removeClass('cart-loading--opens-drawer');
            
            openCartDrawer();

            theme.utils.each(cache.updatedItems, function(updatedItem) {
              var lineItem, previousItem;

              lineItem = '';

              for (var i = 0; i < cart.items.length; i++) {
                if(cart.items[i].id == updatedItem.id){
                  lineItem = cart.items[i];
                }
              }
              if (lineItem) {
                previousItem = ''

                for (var i = 0; i < cache.previousCartItems.length; i++) {
                 if(cache.previousCartItems[i].id == lineItem.id){
                    previousItem = cache.previousCartItems[i];
                 }
                }
              
              }

              if (!previousItem || lineItem.quantity > previousItem.quantity) {
               // showMiniCart(lineItem);
              }
              
            });

          }
        }
      }

      if (theme.CartDrawer.drawerIsOpen && cart.item_count < 1) {
        window.setTimeout(function() {
          theme.CartDrawer.close();
        }, 2500);
      }

      // Update selector caches
      // for (var i = 0; i < theme.current.selected.length; i++) {
      //   // theme.current.selected[i].refreshCartQuantity();

      //   //to do
      // }

    });
  }

  function showMiniCart(lineItem) {
    theme.MiniCart.show(lineItem);
  }

  function initDrawer() {
    $('#MainContent').addClass('drawer-page-content');
    $('.js-drawer-open-top').attr('aria-controls', 'CartDrawer').attr('aria-expanded', 'false');

    theme.CartDrawer = new theme.Drawers('CartDrawer', 'right', {
      onDrawerOpen: cartDrawerOpen,
      beforeDrawerOpen: function(drawer) {
        // theme.MiniCart.close({
        //   direction: 'left'
        // });
      }
    });
  }

  function cartDrawerOpen() {
    // $(selectors.cartToggle).addClass(settings.cartDrawerOpen);
  }

  function cartDrawerClose() {
    // $(selectors.cartToggle).removeClass(settings.cartDrawerOpen);
  }

  function openCartDrawer() {

    // if (isMobile.any) {
    //   console.info('Navigating to cart page');
    //   window.location.href = '/cart';
    // } else {
      
    // }

    theme.CartDrawer.open();

  }

  function showFeedback(status, response, $addToCartForm) {
    $('.ajax-cart-feedback').remove();
    var feedback = '<div class="ajax-cart-feedback ' + status + '">' + response + '</div>';
    
    if ($addToCartForm !== undefined && $addToCartForm.length > 0) {
      switch (settings.feedbackPosition) {
        case 'aboveForm':
          $addToCartForm.before(feedback);
          break;
        case 'belowForm':
          $addToCartForm.after(feedback);
          break;
        case 'afterBody':
          $(document.body).append(feedback);
          break;
        case 'nextButton':
        default:
          $addToCartForm.find(selectors.addToCartBtn).after(feedback);
          break;
      }
    } else {
      // iziToast.show({
      //   message: response,
      //   color: 'red',
      //   position: 'bottomCenter'
      // });
      console.log(response)
    }
    
    var $feedbackElement = $('.ajax-cart-feedback');
    
    $feedbackElement.offset(); // redraw
    $feedbackElement.addClass('active');
    window.setTimeout(function(){
      $feedbackElement.removeClass('active');
    }, 6500);
  };

  return {
    init: init,
    openCartDrawer: openCartDrawer
  };
})();



theme.cartQueue = [];
theme.cartQueueProcessing = false;
theme.processCartQueue = function() {
  // If there's something in the queue, process it
  if (theme.cartQueue.length) {
    theme.cartQueueProcessing = true;
    var request = theme.cartQueue.shift();
    var requestType = request.type || 'add';

    if (requestType == 'add') {
      CartJS.addItem(request.variant_id, request.quantity, request.properties, {
        "success": function(data, textStatus, jqXHR) {
          theme.processCartQueue();
        }
      });
    } else if (requestType == 'update') {
      CartJS.updateItem(line_number, quantity, properties = {}, options = {})
    } else {
      // CartJS.removeItem(line_number, options = {})
    }
    

    ShopifyAPI.addItem(request.variant_id, request.quantity, request.properties, ShopifyAPI.processQueue, requestType);
  }
  else {
    theme.cartQueueProcessing = false;
  }
};

/**
 * Free Gift Product
 * ------------------------------------------------------------------------------
 */

theme.CartGifts = (function() {

  var selectors = {
    dataJsonContainer: '[data-cart-gifts-json]'
  };

  var cache = {};

  function CartGifts(container) {
    this.container = container;
    this.namespace = '.cartGifts';

    if (!this.container) {
      return;
    }

    this.cartGifts = this._getCartGifts();
    this.progressBar = {};

    this._bindCartEventListener();

  }

  CartGifts.prototype = $.extend({}, CartGifts.prototype, {

    _formatProgressGifts: function() {

      var i = this.cartGifts.length, cartGift;

      while(i--) {
        cartGift = this.cartGifts[i];


        if (cartGift.cart_gift_type == 'cart-price-min') {
          cartGift.position_percent = Math.max(Math.min((cartGift.minimum_cart_price - this.progressBar.lowerLimit) / (this.progressBar.upperLimit - this.progressBar.lowerLimit) * 100, 100), 0);
          if (window.shop.cartGifts.progressBar.giftMarkers.indexOf(cartGift) == -1) {
            window.shop.cartGifts.progressBar.giftMarkers.push(cartGift);
          }
        }

      }

    },

    _bindCartEventListener: function() {
      $(document).on('cart.requestComplete' + this.namespace + ' cart.ready' + this.namespace, this._run.bind(this));

      // Force CartJS reload
      CartJS.getCart({success: function() { } })

    },

    _run: function(event, cart) {

      cache.cart = cart;

  
      // Reset options
      window.shop.cartGifts.giftOptions = [];

      this._addEligibleCartGiftsToCart();
      this._findNextEligibleCartGift();
      this._updateProgressBar();
      this._formatProgressGifts();

      // this._buildSuccessMessage();
      // this._addGiftsFromProperties();

    },

    _getVariantsToAdd: function() {
      var variantsToAdd = [];
      var i = cache.cart.items.length;
      while(i--) {
        lineItem = cache.cart.items[i];
        for (var propertyKey in lineItem.properties) {
          if (propertyKey.indexOf('_add-to-cart') > -1) {
            var variantToAdd = lineItem.properties[propertyKey].split(':');
            variantsToAdd.push({
              variantId: variantToAdd[0],
              quantity: variantToAdd[1],
            })
          }
        }
      }
      return variantsToAdd;
    },

    _addGiftsFromProperties: function() {
      var variantsToAdd = this._getVariantsToAdd();

      var variantsAdded = [], i = variantsToAdd.length, variantToAdd;

      while(i--) {
        variantToAdd = variantsToAdd[i];
        if (variantsAdded.indexOf(variantToAdd.variantId) > -1) {
          continue;
        }
        variantsAdded.push(variantToAdd.variantId);
        CartJS.addItem(variantToAdd.variantId, variantToAdd.quantity, { '_is_free_gift': 'true' })
      }

    },


    _updateProgressBar: function() {

     var i = this.cartGifts.length, cartGift, lowerLimitCartGiftPrice, upperLimitCartGiftPrice, limitPadding, totalPrice;

      while(i--) {
        cartGift = this.cartGifts[i];

        if (cartGift.cart_gift_type == 'cart-price-min') {
          if (!upperLimitCartGiftPrice || (upperLimitCartGiftPrice && upperLimitCartGiftPrice < cartGift.minimum_cart_price)) {
            upperLimitCartGiftPrice = parseInt(cartGift.minimum_cart_price);
          }
          if (!lowerLimitCartGiftPrice || (lowerLimitCartGiftPrice && lowerLimitCartGiftPrice > cartGift.minimum_cart_price)) {
            lowerLimitCartGiftPrice = parseInt(cartGift.minimum_cart_price);
          }
        }
      }

      limitPadding = upperLimitCartGiftPrice / 8;
      totalPrice = cache.cart.total_price;

      this.progressBar.upperLimit = upperLimitCartGiftPrice + limitPadding;
      this.progressBar.lowerLimit = Math.min(lowerLimitCartGiftPrice - limitPadding, Math.max(totalPrice - limitPadding, 0));
      this.progressBar.progressPercent = (totalPrice - this.progressBar.lowerLimit) / (this.progressBar.upperLimit - this.progressBar.lowerLimit) * 100;

      window.shop.cartGifts.progressBar.progressPercent = this.progressBar.progressPercent;

    },

    _findNextEligibleCartGift: function() {

      var i = this.cartGifts.length, cartGift, nextCartGift;

      while(i--) {
        cartGift = this.cartGifts[i];

        if (cartGift.cart_gift_type == 'cart-price-min' && cartGift.minimum_cart_price > cache.cart.total_price) {
          if (!nextCartGift || (nextCartGift && nextCartGift.minimum_cart_price > cartGift.minimum_cart_price)) {
            nextCartGift = cartGift
          }
        }
      }

      this._setNextCartGift(nextCartGift);

    },

    _setNextCartGift: function(cartGift) {

      if (cartGift) {
        var nextPriceCartTotalDifferenceCents = cartGift.minimum_cart_price - cache.cart.total_price;
        cartGift.cart_cta_message_formatted = cartGift.cart_cta_message.replace('[price]', theme.Currency.formatMoney(nextPriceCartTotalDifferenceCents)) + ' '+ '<strong>'+cartGift.label+'</strong>';

      }

      window.shop.cartGifts.next = cartGift;
    },

    _addEligibleCartGiftsToCart: function() {

      var i = this.cartGifts.length, cartGift, lineItemInCart, isEligible;

      while(i--) {
        cartGift = this.cartGifts[i];

        isInCart = cartGift.isIncart(cache.cart);
        isEligible = cartGift.isEligible(cache.cart);

        if (isEligible && !isInCart) {
          if (cartGift.type == 'cart-gift-options' || cartGift.type == 'tier-gifts' || cartGift.type == 'product-specific') {
            this._displayGiftOffer(cartGift, cache.cart);
          } else {
            cartGift.addToCart(cache.cart);
            window.shop.cartGifts.strings = cartGift;
            window.shop.cartGifts.strings.cart_cta_successmessage_formatted = cartGift.success_title + ' <strong>'+cartGift.label+'</strong>';
            

          }
        }

        if (isEligible) {
          cartGift.is_in_cart = true;
        } else {
          cartGift.is_in_cart = false;
        }

      }
    },

    // loadGiftsInCartMessage: function(){
    //   window.shop.cartGifts.recieved = 'Congratulations you have received';

    //   for (var i = 0; i < this.cartGifts.length; i++) {
    //     var cartGift = this.cartGifts[i];
    //     if(this.cartGifts[i].is_in_cart){
    //        window.shop.cartGifts.recieved +=  ', ' + this.cartGifts[i].label;
    //     }
    //   }
    // },

    _displayGiftOffer: function(cartGift, cart) {

      if (window.shop.cartGifts.giftOptions.length) {
        return;
      }

      var products = cartGift.options;
      if (cartGift.type == 'tier-gifts') {
        products = cartGift.options;
        cartGift.loadTierProducts(products);
        window.shop.cartGifts.giftOptions = cartGift.options;
        window.shop.cartGifts.slider = cartGift.options && cartGift.options.length > 0;
        window.shop.cartGifts.strings = cartGift;
        window.shop.cartGifts.max_selected = cartGift.max_selected;
        window.shop.cartGifts.selected = [];
        window.shop.cartGifts.strings.cart_cta_successmessage_formatted = cartGift.success_title +' <strong>'+cartGift.label+'</strong>';
      }
      if (cartGift.type == 'product-specific') {
        products = cartGift.options;
        cartGift.loadTierProducts(products);
        window.shop.cartGifts.giftOptions = cartGift.options;
        window.shop.cartGifts.slider = cartGift.options && cartGift.options.length > 0;
        window.shop.cartGifts.strings = cartGift;
        window.shop.cartGifts.max_selected = cartGift.max_selected;
        window.shop.cartGifts.selected = [];
        window.shop.cartGifts.strings.cart_cta_successmessage_formatted = cartGift.success_title + ' <strong>'+(cartGift.max_selected)+' '+cartGift.label+(cartGift.max_selected > 1 ? 's': '')+'</strong>';
        
      }
      if (cartGift.type == 'product-specific-multiple') {
        products = cartGift.options;
        cartGift.loadTierProducts(products);
        window.shop.cartGifts.giftOptions = cartGift.options;
        window.shop.cartGifts.slider = cartGift.options && cartGift.options.length > 0;
        window.shop.cartGifts.strings = cartGift;
        window.shop.cartGifts.max_selected = cartGift.max_selected;
        window.shop.cartGifts.selected = [];
        window.shop.cartGifts.strings.cart_cta_successmessage_formatted = cartGift.success_title + ' <strong>'+(cartGift.max_selected)+' '+cartGift.label+(cartGift.max_selected > 1 ? 's': '')+'</strong>';
        
      }
      else {
        cartGift.loadProducts(products);
        window.shop.cartGifts.giftOptions = cartGift.options;
        window.shop.cartGifts.slider = cartGift.options && cartGift.options.length > 0;
        window.shop.cartGifts.strings.cart_cta_successmessage_formatted = cartGift.success_title + ' <strong>'+cartGift.label+'</strong>';
        
      }

      
    },

    _getCartGifts: function() {
      var dataJsonContainer = this.container.querySelector(selectors.dataJsonContainer);

      if (!dataJsonContainer) {
        return
      }

      return theme.utils.map(JSON.parse(dataJsonContainer.innerHTML), function(cartGift) {
        return new CartGift(cartGift);
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      $(document).off(this.namespace);
    }
  });

  function CartGift(data) {
    theme.utils.extend(this, data);
    // this.tooltip = {
    //   content: data.tooltip_message,
    //   theme: 'light'
    // }

    if (data.type == 'cart-gift-options') {
      function Option(option) {
        theme.utils.extend(this, option);
      }
      this.options.map(function(option) {
        option.cart_gift_type = data.cart_gift_type;
        return new Option(option)
      })
    }

    // if (data.type == 'product-specific' || data.type == 'auto-specific' ) {
    //   $.get('/collections/' + this.collection_to_match + '?view=json', function(data) {
    //     collection = JSON.parse(data, 'shopify');
    //     this.products_to_match = collection;
    //   });
    // }
  }

  CartGift.prototype = $.extend({}, CartGift.prototype, {


    loadTierProducts: function(products) {

      products.forEach(function(option) {

        if (option.loading) {
          return;
        }

        option.loading = true;

        $.get('/products/' + option.product_handle + '?view=json', function(data) {
          option.product = JSON.parse(data, 'shopify');

          option.variant = '';
          if (option.image) {
            option.featured_image = option.featured_image || option.image;
            delete option.image;
          }
          option.selected = false;

          option.variant = option.product.variants[0];
          option.product_variant_id = option.variant.id;
          if (window.shop.cartGifts.selected.indexOf(option.variant.id) > -1) {
            option.selected = true;
          }

          var cartVariants = cache.cart.items.map(function(item){
            return item.id;
          })
          if (cartVariants.indexOf(option.variant.id) > -1) {
            option.selected = true;
            if (!window.shop.cartGifts.selected.indexOf(option.variant.id) > -1) {
              window.shop.cartGifts.selected.push(option.variant.id);
            }
            
          }
          window.shop.cartGifts.selectedCount = window.shop.cartGifts.selected.length;

          option.displayPrice = option.percentage < 100 && option.variant ? Math.round(option.variant.price * (option.percentage * 0.01)) : false;
          option.loading = false;
        })

      })
    },

    loadProducts: function(products) {

      products.forEach(function(option) {

        if (option.products || option.loading) {
          return;
        }

        option.loading = true;

        $.get('/products/' + option.product_handle + '?view=json', function(data) {
          option.product = JSON.parse(data, 'shopify');

          option.variant = '';
          for (var i = 0; i < option.product.variants.length; i++) {
           if(option.product.variants[i].id == parseInt(option.product_variant_id)){
            option.variant = option.product.variants[i];
           } 
          }
          

          option.displayPrice = option.percentage < 100 && option.variant ? Math.round(option.variant.price * (option.percentage * 0.01)) : false;
          option.loading = false;
        })

      })
    },


    getLineItemFromCart: function(cart, itemId) {

      var i = cart.items.length, item;
        while(i--) {
        if (cart.items[i].properties['_item_id'] && cart.items[i].properties['_item_id'] == itemId) {
          return cart.items[i];
        }
      }
      return;

    },

    getVariantFromCart: function(cart, itemId) {

      var i = cart.items.length, item;
        while(i--) {
        if (cart.items[i].id == itemId) {
          return cart.items[i];
        }
      }
      return;

    },

    removeFromCart: function(lineItem) {
      CartJS.removeItem(lineItem.line_number);
    },

    isIncart: function(cart) {
      var self = this;

      switch(this.type) {
        case 'cart-gift':

          return !!this.getLineItemFromCart(cart, this.item_id);
          break;

        case 'tier-gifts':
          return false;
          break;

        case 'product-specific':

          var itemsMatchInCart = theme.utils.map(this.products_to_match, function(product) {
            return !!self.getLineItemFromCart(cart, product.variants[0].id);
          });

          return itemsMatchInCart.indexOf(true) > -1;
          break;

        case 'auto-specific':

          return !!self.getVariantFromCart(cart, parseInt(this.variant_id));

          break;

        case 'auto-specific-count':

          return !!self.getVariantFromCart(cart, parseInt(this.variant_id));

          break;

        case 'auto-specific-all':

          return !!self.getVariantFromCart(cart, parseInt(this.variant_id));

          break;

        case 'member-gift':

          return !!self.getVariantFromCart(cart, parseInt(this.variant_id));
          
          break;

        case 'cart-gift-options':

          var itemsMatchInCart = theme.utils.map(this.options, function(product) {
            return !!self.getLineItemFromCart(cart, product.item_id);
          });

          return itemsMatchInCart.indexOf(true) > -1;
          break;

        case 'free-shipping':

          return !!this.getPropertyFromCart('_free_shipping', cart);
          break;

      }
    },

    getPropertyFromCart: function(property, cart) {

      var i = cart.items.length, item;
        while(i--) {
          if (cart.items[i].properties[property]) {
            return cart.items[i].properties[property];
          }
      }
      return;

    },

    isEligible: function(cart) {

      switch (this.cart_gift_type) {

        case 'cart-price-min':
          return cart.total_price >= this.minimum_cart_price;

        case 'tier-gifts':

          if (this.maximum_cart_price == 0) {
            return cart.total_price >= this.minimum_cart_price
          }
          else {
            return cart.total_price >= this.minimum_cart_price && cart.total_price <= this.maximum_cart_price;
          }
        
        case 'member-gift':

          return true;
          break;

        case 'product-specific':

          var variantsToMatch = this.variants_to_match;

          var cartMatchCount = 0;
          for (var i = 0; i < cart.items.length; i++) {
            if(variantsToMatch.indexOf(cart.items[i].variant_id.toString()) > -1){
              cartMatchCount += cart.items[i].quantity;
            }
          }

          this.max_selected = cartMatchCount >= 4 ? 4 : cartMatchCount;

          return cartMatchCount > 0;
          break;

        case 'auto-specific':

          var variantsToMatch = this.variants_to_match;

          var cartMatchCount = 0;
          for (var i = 0; i < cart.items.length; i++) {
            if(variantsToMatch.indexOf(cart.items[i].variant_id.toString()) > -1){
              cartMatchCount += cart.items[i].quantity;
            }
          }

          this.max_selected = cartMatchCount >= 4 ? 4 : cartMatchCount;

          if (this.match_all) {
            return cartMatchCount == variantsToMatch.length;
          }
          else {
            return cartMatchCount > 0;
          }
          
          break;

        case 'auto-specific-count':

          var variantsToMatch = this.variants_to_match;

          var cartMatchCount = 0;
          for (var i = 0; i < cart.items.length; i++) {
            if(variantsToMatch.indexOf(cart.items[i].variant_id.toString()) > -1){
              cartMatchCount += cart.items[i].quantity;
            }
          }

          this.max_selected = cartMatchCount >= 4 ? 4 : cartMatchCount;

          return cartMatchCount == this.selection_count;

          
          break;

        case 'auto-specific-all':
          var inCartMatch = {};
          var cartVariants = [];

          var products = this.options;

           products.forEach(function(option) {
            for (var i = 0; i < cache.cart.items.length; i++) {
              var item = cache.cart.items[i];
              if(item.id == option.variant.id){
                option.selected = item.quantity;
                if(item.quantity > 1){
                  for (var k = 0; k < item.quantity; k++) {
                    cartVariants.push(item);
                  }
                }
                else {
                  cartVariants.push(item);
                }
              }
            }
            
          });

          this.selected = cartVariants;
          this.selectedCount = this.selected.length;

          if (this.selectedCount <= this.max_selected) {
            return false;
          }
          return true;
          
          break;

        case 'item-property':
          var i = cart.items.length, item;
            while(i--) {
            item = cart.items[i];
            if (item.properties && item.properties[this.eligibility_property]) {
              return true;
            }
          }
          return false;
      }

    },

    addToCart: function(cart) {
      var self = this;

      if (self.requestQueued) {
        return;
      }

      self.requestQueued = true;

      if (document.body.classList.contains('cart-loading')) {
        console.info('Cart is loading. Waiting before applying cart gift.');

        $(document).on('cart.requestComplete.' + self.item_id, function() {

          if (document.body.classList.contains('cart-loading')) {
            console.info('Still loading, waiting before applying cart gift.');
            return;
          }

          $(document).off('cart.requestComplete.' + self.item_id);
          apply();
        });

      } else {

        apply()

      }

      function apply() {
        console.info('Applying cart gift');
        // if you see this call too mamny times then the shopify script is continually removing the product so the success method is still calling but the cart update returns no gift in cart so it tries again forever

        switch (self.type) {

          case 'cart-gift':

            if (self.failureOnAdd) {
              console.error('failed to add to cart');
              return false;
            }

            var properties = {
              '_is_free_gift': self.cart_gift_type,
              '_item_id': self.item_id,
              '_group_id': self.group_id,
              '_hide_quantity': true
            }

            if (self.requires_product) {
              properties._requires_product = parseInt(self.requires_product);
            }

            if (self.minimum_cart_price) {
              properties._min_price = self.minimum_cart_price;
            }

            if (self.match_all) {
              properties._match_all = self.match_all;
            }

            CartJS.addItem(self.variant_id, 1, properties, {
              "error": function(jqXHR, textStatus, errorThrown) {
                  self.failureOnAdd = true;
                  self.requestQueued = false;
              },
              "success": function(jqXHR, textStatus, errorThrown) {
                  self.requestQueued = false;
              }
            });
            break;

          case 'member-gift':

            if (self.failureOnAdd) {
              console.error('failed to add to cart');
              return false;
            }

            var properties = {
              '_is_free_gift': self.cart_gift_type,
              '_item_id': self.item_id,
              '_group_id': self.group_id,
              '_hide_quantity': true,
              '_member_gift': self.variant_id
            }

            if (self.requires_product) {
              properties._requires_product = parseInt(self.requires_product);
            }

            if (self.minimum_cart_price) {
              properties._min_price = self.minimum_cart_price;
            }

            if (self.match_all) {
              properties._match_all = self.match_all;
            }

            CartJS.setNote(self.received_tag, {});
            CartJS.addItem(self.variant_id, 1, properties, {
              "error": function(jqXHR, textStatus, errorThrown) {
                  self.failureOnAdd = true;
                  self.requestQueued = false;
              },
              "success": function(jqXHR, textStatus, errorThrown) {
                  self.requestQueued = false;
              }
            });
            break;

          case 'auto-specific':

            if (self.failureOnAdd) {
              console.error('failed to add to cart');
              return false;
            }

            var properties = {
              '_is_free_gift': self.cart_gift_type,
              '_item_id': self.item_id,
              '_group_id': self.group_id,
              '_hide_quantity': true
            }

            if (self.requires_product) {
              properties._requires_product = parseInt(self.requires_product);
            }

            if (self.minimum_cart_price) {
              properties._min_price = self.minimum_cart_price;
            }

            if (self.match_all) {
              properties._match_all = self.match_all;
            }

            CartJS.addItem(self.variant_id, 1, properties, {
              "error": function(jqXHR, textStatus, errorThrown) {
                  self.failureOnAdd = true;
                  self.requestQueued = false;
              },
              "success": function(jqXHR, textStatus, errorThrown) {
                  self.requestQueued = false;
              }
            });
            break;

          case 'auto-specific-count':

            if (self.failureOnAdd) {
              console.error('failed to add to cart');
              return false;
            }

            var properties = {
              '_is_free_gift': self.cart_gift_type,
              '_item_id': self.item_id,
              '_group_id': self.group_id,
              '_hide_quantity': true
            }

            if (self.requires_product) {
              properties._requires_product = parseInt(self.requires_product);
            }

            if (self.minimum_cart_price) {
              properties._min_price = self.minimum_cart_price;
            }

            properties._match_count = self.selection_count;
            


            CartJS.addItem(self.variant_id, 1, properties, {
              "error": function(jqXHR, textStatus, errorThrown) {
                  self.failureOnAdd = true;
                  self.requestQueued = false;
              },
              "success": function(jqXHR, textStatus, errorThrown) {
                  self.requestQueued = false;
              }
            });
            break;
          
          case 'auto-specific-all':

            if (self.failureOnAdd) {
              console.error('failed to add to cart');
              return false;
            }

            var properties = {
              '_is_free_gift': self.cart_gift_type,
              '_item_id': self.item_id,
              '_group_id': self.group_id,
              '_hide_quantity': true
            }

            if (self.requires_product) {
              properties._requires_product = parseInt(self.requires_product);
            }

            if (self.minimum_cart_price) {
              properties._min_price = self.minimum_cart_price;
            }

            if (self.match_all) {
              properties._match_all = self.match_all;
            }

            CartJS.addItem(self.variant_id, 1, properties, {
              "error": function(jqXHR, textStatus, errorThrown) {
                  self.failureOnAdd = true;
                  self.requestQueued = false;
              },
              "success": function(jqXHR, textStatus, errorThrown) {
                  self.requestQueued = false;
              }
            });
            
            break;

          case 'free-shipping':

            console.info('Applying free shipping');

            var firstLineItem = cart.items[0];

            if (!firstLineItem) {
              self.requestQueued = false;
              return;
            }

            var lineNumber = firstLineItem.line_number;
            var quantity = firstLineItem.quantity;
            var properties = firstLineItem.properties;

            properties['_free_shipping'] = self.item_id;

            CartJS.updateItem(lineNumber, quantity, properties);

            self.requestQueued = false;

            break;

          }
        }

      }

  })

  return CartGifts;
})();


window.theme = window.theme || {};

theme.OnlinePartnerLinks = (function() {
  var selectors = {
    onlinePartner: 'online_partner'
  }
  function OnlinePartnerLinks() {
    var queryparams = theme.utils.getQueryParams();
    if(!queryparams){
      return;
    }
    
    var onlinePartnerId = queryparams[selectors.onlinePartner];
    if(!onlinePartnerId){
      return;
    }

    CartJS.setAttribute('onlinePartner', onlinePartnerId);
  }


  return OnlinePartnerLinks;

})();

/**
 * Page load actions
 * ------------------------------------------------------------------------------
 */

document.addEventListener("DOMContentLoaded", function(event) {

	theme.AjaxCart.init();
  new theme.OnlinePartnerLinks();

  var cartGiftsContainer = document.querySelector('[data-section-type="cart-gifts"]');
  if (cartGiftsContainer) {
    new theme.CartGifts(cartGiftsContainer);
  }
	var acc = document.getElementsByClassName("faqAccordion");
	var i;

	for (i = 0; i < acc.length; i++) {
	  acc[i].addEventListener("click", function() {
	    this.classList.toggle("faqAccordionActive");
	    var faqAccordionPanel = this.nextElementSibling;
	    if (faqAccordionPanel.style.maxHeight) {
	      faqAccordionPanel.style.maxHeight = null;
	    } else {
	      faqAccordionPanel.style.maxHeight = faqAccordionPanel.scrollHeight + "px";
	    }
	  });
	}
	
	var variantSelector = document.querySelectorAll('.option-value-input');
	var paymentMethods = document.querySelectorAll('[data-installments-count]');

	for (var i = 0; i < variantSelector.length; i++) {

		variantSelector[i].addEventListener('click',function(){
      $('.duration-message').hide();
      $('#amount-' + this.value + '.duration-message').show();


          setTimeout(function (){
            var productPriceSpan = document.querySelector('.product-main .price--main[data-price]');
            var productPrice = productPriceSpan.innerText.replace('$','').replace('.','').replace('NZ','');

            for (var i = 0; i < paymentMethods.length; i++) {
              var method = paymentMethods[i];
              var installmentsCount = method.dataset.installmentsCount;
              var newPrice = parseFloat(parseInt(productPrice) / parseInt(installmentsCount));
              method.textContent = '$' + (newPrice / 100).toFixed(2);
            }
          },200);
		});
	}

  $('body').on('click', '.atc-button--viewcart', function(){
    $('body').trigger('click');
    CartJS.getCart({
      success: function() { 
      theme.CartDrawer.open();
      }
    })
    
  });

  
  window.api.theme.useValue('cart:total', function() {
    CartJS.getCart({
      success: function() { 
        theme.CartDrawer.open();
      }
    });
  });

	
});

